import { Mui } from "@osu/react-ui";
import DashboardAlert from "../../../Dashboard/components/Alert";

const Preview = ({ message }) => {
  if(!message) {
    return false
  }
  return (
    <Mui.Paper variant="outlined"  sx={{ padding: 2, mt: 2, width: '100%' }} >
      <Mui.Typography variant="subtitle1" component="h3">
        Preview
      </Mui.Typography>
      <DashboardAlert  sx={{ width: '100%' }} role="none" message={message} />
    </Mui.Paper>
  );
};

export default Preview;
